import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import qs from 'qs';
import Header from './Header';

function VerificationPage() {

    const navigate = useNavigate();
    const { guid } = useParams();
    const [data, setData] = useState(
{
        FirstName: '',
        LastName: '',
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [email, setEmail] = useState('');
    const [lastName, setLastName] = useState('');

    useEffect(() => {

        const getAuthToken = async () => {
            try {
                const authResponse = await axios.post(
                    '/proxy/token', // Replace with your auth URL
                    qs.stringify({
                        username: process.env.REACT_APP_ENGAGE_API_USERNAME,
                        password: process.env.REACT_APP_ENGAGE_API_PASSWORD,
                        grant_type: 'password',
                        client_id: process.env.REACT_APP_ENGAGE_API_CLIENT_ID,
                        client_secret: process.env.REACT_APP_ENGAGE_API_CLIENT_SECRET
                    }),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }
                );

                return authResponse.data.access_token;

            } catch (err) {
                if (err.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.error('Response data:', err.response.data);
                    console.error('Response status:', err.response.status);
                    console.error('Response headers:', err.response.headers);
                } else if (err.request) {
                    // The request was made but no response was received
                    console.error('Request data:', err.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.error('Error message:', err.message);
                }
                console.error('Config:', err.config);
                throw new Error('Failed to get authorization token');
            }
        };

        const fetchData = async (token) => {
            console.log(token);
            try {
                const response = await axios.get(
                    `/proxy/api/1.0/integration/iupat/edocs/${guid}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                setData(response.data);

            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        }

        const init = async () => {
            try {
                const token = await getAuthToken();
                await fetchData(token);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };


        init();
        setLoading(false);
    }, [guid]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (email.trim().toUpperCase() === data.EmailAddress.trim().toUpperCase() &&
            lastName.trim().toUpperCase() === data.LastName.trim().toUpperCase()) {
            navigate('/home', { state: {data} });
        } else {
            alert('The email address and last name do not match.');
        }
    };

    if(loading) return <p>Loading...</p>;
    if(error) return <p>Error: {error}</p>;

    return (
        <div id='content'>
            <Header />
            <div id='instructions'>Please Verify Your Identity</div>
            <form onSubmit={handleSubmit}>
                <div>
                    <label>Email Address:</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Last Name:</label>
                    <input
                        type="text"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                    />
                </div>
                <button type="submit">Submit</button>
            </form>
        </div>
    )
}

export default VerificationPage;
